<template>
    <RegularModal ref="modal">
        <template v-slot:title>{{ translate("admin_fights_manage.insert_break_before") }}</template>
        <template v-slot:body>
            <div class="columns">
                <div class="column">
                    <div class="field">
                        <label class="label">{{ translate("admin_fights_manage.time_of_break") }}</label>
                        <div class="control">
                            <input class="input" type="number" v-model="timeOfBreakInMins" min="1" />
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="buttons">
                <button class="button" @click="close">{{ translate("common.cancel") }}</button>
                <button class="button is-primary" @click="confirm" :disabled="isInvalidValue">
                    {{ translate("common.ok") }}
                </button>
            </div>
        </template>
    </RegularModal>
</template>

<script setup lang="ts">
    import RegularModal from "../Common/RegularModal.vue";
    import { ref, computed } from "vue";
    import translatorMixin from "../Common/translatorMixin";
    import { OrganizerComplexFight } from "../Common/Fights/types";

    const { translate } = translatorMixin.methods;

    const emit = defineEmits(["result"]);

    const modal = ref<InstanceType<typeof RegularModal> | null>(null);
    const timeOfBreakInMins = ref(0);
    const fightToPassWhenConfirming = ref<OrganizerComplexFight | null>(null);

    const isInvalidValue = computed(() => {
        const timeValue = timeOfBreakInMins.value;
        return timeValue === null || timeValue === undefined || timeValue <= 0;
    });

    function open(fight: OrganizerComplexFight) {
        modal.value?.open();
        timeOfBreakInMins.value = 0;
        fightToPassWhenConfirming.value = fight;
    }

    function close() {
        modal.value?.close();
    }

    function confirm() {
        if (isInvalidValue.value) {
            return;
        }

        emit("result", timeOfBreakInMins.value, fightToPassWhenConfirming.value);

        close();
    }

    defineExpose({ open, close });
</script>

<style scoped></style>
